    <div class="mgbt-x-small">
        <div fxLayout="row wrap" class="fxGap-medium">
            <div style="min-width: 100px;">
                <strong>Available {{planType}} plans:</strong> 
            </div>
            <div style="min-width: 150px;" *ngIf="isHCAEditOrAdmin && planType === 'Medical'">
                <checkbox name="showAll" [(ngModel)]="showAll" (change)="showAllChange()">See all plans</checkbox>
            </div>
        </div>
    </div>
    <div *ngIf="planType === 'Vision'" class="mgbt-small">
        <span *ngIf="isPebb && isNewlyEligible">
            Select a vision plan. Before you enroll, make sure the provider you want to use accepts the plan you choose. If you do not choose a vision plan within 31-days from your eligibility date, you will be enrolled in MetLife Vision.
        </span>
        <span *ngIf="!isPebb && isNewlyEligible">
            Select a vision plan. Before you enroll, make sure the provider you want to use accepts the plan you choose. If you do not choose a vision plan, you will be enrolled in MetLife Vision.
        </span>
        <span *ngIf="!isNewlyEligible">
            Select a vision plan. Before you enroll, make sure the provider you want to use accepts the plan you choose.
        </span>
    </div>
    <generic-grid
        *ngIf="availablePlans"
        [gridColumns]="availablePlanColumns"
        [gridData]="availablePlanClone"
        (selectedRow)="onPlanSelected($event)"
        (deselectedRow)="onPlanDeSelected($event)"
        [selectBy]="'planId'"
        [selectedKeys]="selectedPlanId"
        [selectable]="!isWaived && !readonly"
        [showSelectionHeader]="true"
    >
    </generic-grid>
    <!--  -->